import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_COM009_Request,
  IAPI_COM009_Response,
  IAPI_RET015_Request,
  IAPI_RET015_Response,
} from "../../../type/apiType";

import {
  IAPI_RET016_Request,
  IAPI_RET016_Response,
} from "../../../type/apiType";

import {
  IAPI_COM005_Request,
  IAPI_COM005_Response,
} from "../../../type/apiType";

// 退職手当金の請求手続き又は合算制度利用手続き確認表示API
// API仕様書_退職者
const httpAPI_RET015 = async (
  param: IAPI_RET015_Request
): Promise<IAPI_RET015_Response> => {
  let res = await http.post(ApiUrl.API_RET015, {
    ...param,
  });

  return res.data;
};

// 退職手当金請求、合算制度利用不要データ削除API
// API仕様書_退職者
const httpAPI_RET016 = async (
  param: IAPI_RET016_Request
): Promise<IAPI_RET016_Response> => {
  let res = await http.post(ApiUrl.API_RET016, {
    ...param,
  });

  return res.data;
};

// 帳票ダウンロード(汎用)API
// API仕様書_共通
const httpAPI_COM005 = async (
  param: IAPI_COM005_Request
): Promise<IAPI_COM005_Response> => {
  let res = await http.post(ApiUrl.API_COM005, {
    ...param,
  });

  return res.data;
};

// 帳票作成状況取得API
const httpAPI_COM009 = async (
  param: IAPI_COM009_Request
): Promise<IAPI_COM009_Response> => {
  let res = await http.post(ApiUrl.API_COM009, {
    ...param,
  });

  return res.data;
};

export { httpAPI_RET015, httpAPI_RET016, httpAPI_COM005, httpAPI_COM009 };
